import SectionHeading from "./SectionHeading";
import { hotList } from "@/mocks/trending";
import { categoryName } from "@/mocks/categories";

interface HotListProps {
  onOpenCategory: (id: string) => void;
}

const rankClass = (i: number) => {
  if (i === 0) return "bg-accent-500 text-background-50";
  if (i === 1) return "bg-primary-500 text-background-50";
  if (i === 2) return "bg-secondary-600 text-background-50";
  return "bg-secondary-100 text-secondary-800";
};

export default function HotList({ onOpenCategory }: HotListProps) {
  return (
    <section id="hotlist" className="scroll-mt-24 border-y border-background-200/70 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <SectionHeading
          eyebrow="Trending Now"
          title="今日热榜，谁在风口浪尖"
          desc="按实时热度排序的瓜料 Top 榜单，一眼看清当下最受关注的话题与现场。"
        />

        <ol className="grid gap-3 md:grid-cols-2">
          {hotList.map((h, i) => (
            <li key={h.id}>
              <button
                onClick={() => onOpenCategory(h.categoryId)}
                className="group flex w-full items-center gap-4 rounded-2xl border border-background-200/80 bg-background-50 p-4 text-left transition-colors hover:border-primary-200"
              >
                <span
                  className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl font-heading text-xl font-black ${rankClass(i)}`}
                >
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="min-w-0 flex-1">
                  <span className="flex items-center gap-2">
                    <span className="whitespace-nowrap rounded px-1.5 py-0.5 text-[11px] font-semibold text-secondary-800 bg-secondary-100">
                      {categoryName(h.categoryId)}
                    </span>
                    <span className="whitespace-nowrap rounded px-1.5 py-0.5 text-[11px] font-semibold text-accent-700 bg-accent-100">
                      {h.tag}
                    </span>
                  </span>
                  <span className="mt-1.5 block truncate text-sm font-semibold text-foreground-900 group-hover:text-primary-700">
                    {h.title}
                  </span>
                </span>
                <span className="shrink-0 text-right">
                  <span className="flex items-center justify-end gap-1 text-xs font-semibold text-primary-600">
                    <i className="ri-fire-fill text-accent-500"></i>
                    {h.heat}
                  </span>
                  <span className="mt-1 hidden items-center gap-1 text-xs text-foreground-500 sm:flex">
                    去围观 <i className="ri-arrow-right-line text-accent-500"></i>
                  </span>
                </span>
              </button>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}